import { useCallback, useMemo } from 'react';

import click from '@gojob/tracking/click';

import useOfferListType from 'src/tracking/OfferListTypeProvider/useOfferListType';
import { Job } from 'src/types/gojob';

const useTrackOfferClick = () => {
  const type = useOfferListType();

  const eventAction = useMemo(() => {
    switch (type) {
      case 'jobboard-nearby-offers':
      case 'jobboard-offer-nearby-offers':
        return 'nearby-offers-click-offer';
      case 'jobboard-similar-offers':
      case 'jobboard-offer-similar-offers':
        return 'similar-offers-click-offer';
      default:
        return 'standard-click-offer';
    }
  }, [type]);

  const eventCategory = useMemo(() => {
    switch (type) {
      case 'jobboard-offer-similar-offers':
      case 'jobboard-offer-nearby-offers':
        return 'offer-jobboard';
      default:
        return 'jobboard';
    }
  }, [type]);

  const trackOfferClick = useCallback(
    (job?: Job) => {
      if (job) {
        const jobCaption = job?.caption?.substring(0, 30);
        click({
          eventAction,
          eventCategory,
          eventName: `${jobCaption}-${job?.id}`,
        });
      }
    },
    [eventAction]
  );

  return trackOfferClick;
};

export default useTrackOfferClick;
